export enum BasketItemType
{
    Unset = "Unset",
    Rent = "Rent",
    Sale = "Sale",
    Service = "Service",
    Help = "Help"
}
